module.exports = __webpack_public_path__ + "static/media/3Crv-logo.a29563db.png";